import React from 'react';
import { CheckCircle2, XCircle, Zap } from 'lucide-react';
const comparisons = [{
  feature: 'Enfoque',
  other: 'Templates genéricos para cualquier negocio',
  us: 'Construido exclusivamente para contractors'
}, {
  feature: 'Estrategia',
  other: 'Solo enfocado en diseño',
  us: 'Diseño + estrategia de conversión'
}, {
  feature: 'Precio',
  other: 'Mensualidades costosas obligatorias',
  us: 'Un solo pago de $250, sin mensualidades forzadas'
}, {
  feature: 'Tiempo',
  other: 'Semanas o meses para lanzar',
  us: 'Listo en menos de 72 horas'
}, {
  feature: 'Visibilidad',
  other: 'Sin estrategia de SEO',
  us: 'SEO local incluido desde el primer día'
}, {
  feature: 'Soporte',
  other: 'Sin soporte después del lanzamiento',
  us: 'Mantenimiento opcional disponible'
}, {
  feature: 'Resultados',
  other: 'Se ve bien pero no convierte',
  us: 'Construido para convertir visitas en llamadas'
}];
export function MechanismSection() {
  return <section className="py-24 bg-dark-100 relative overflow-hidden" data-id="element-207" data-mp="7qh7kv8vexjs">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent" data-id="element-208" data-mp="cpbrk0ikqs5h"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-209" data-mp="3u3h632g3q3p0">
        <div className="text-center mb-16" data-id="element-210" data-mp="2y7c6zozl5a4">
          <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full bg-gold/10 border border-gold/20 mb-6" data-id="element-211" data-mp="2ww80yrmpvih">
            <Zap className="w-4 h-4 text-gold mr-2" data-id="element-212" data-mp="3q4htqws1j4nj" />
            <span className="text-gold text-sm font-bold tracking-wide uppercase" data-id="element-213" data-mp="3q59m7yqccm9l">
              La Solución
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-214" data-mp="3g590k6501u28">
            Presentamos The Professional Presence System
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-215" data-mp="19g47my5ick79">
            La solución digital completa creada exclusivamente para contractors
            locales que quieren verse tan profesionales como trabajan — por un
            solo pago accesible y sin complicaciones.
          </p>
        </div>

        <div className="bg-dark rounded-3xl border border-white/10 overflow-hidden shadow-2xl" data-id="element-216" data-mp="17wuj8lp34wgx">
          <div className="grid grid-cols-3 bg-dark-200 border-b border-white/10 p-6" data-id="element-217" data-mp="12zcg5bxr1bgu">
            <div className="col-span-1 font-bold text-gray-400 uppercase text-sm tracking-wider" data-id="element-218" data-mp="yz2179rzbapu">
              Característica
            </div>
            <div className="col-span-1 font-bold text-gray-500 uppercase text-sm tracking-wider text-center" data-id="element-219" data-mp="1qox120dgqisr">
              Otras Opciones
            </div>
            <div className="col-span-1 font-bold text-gold uppercase text-sm tracking-wider text-center" data-id="element-220" data-mp="1lwdkqvne59k9">
              AS Elite Contractor
            </div>
          </div>

          <div className="divide-y divide-white/5" data-id="element-221" data-mp="2ef9grxey9jtw">
            {comparisons.map((item, index) => <div key={index} className="grid grid-cols-3 p-6 items-center hover:bg-white/[0.02] transition-colors" data-id="element-222" data-mp="29mgb97bnq7gr" data-mpi={index}>
                <div className="col-span-1 text-sm md:text-base font-medium text-gray-300 pr-4" data-id="element-223" data-mp="13ohzs0rs4me">
                  {item.feature}
                </div>
                <div className="col-span-1 flex flex-col items-center text-center px-2" data-id="element-224" data-mp="5404zbgluh11">
                  <XCircle className="w-5 h-5 text-red-500/50 mb-2" data-id="element-225" data-mp="a5fr76uiqtl0" />
                  <span className="text-sm text-gray-500" data-id="element-226" data-mp="f490en2rvyfd">{item.other}</span>
                </div>
                <div className="col-span-1 flex flex-col items-center text-center px-2" data-id="element-227" data-mp="k2aojmf22nxp">
                  <CheckCircle2 className="w-6 h-6 text-gold mb-2" data-id="element-228" data-mp="otsj9sqhjsa8" />
                  <span className="text-sm font-bold text-white" data-id="element-229" data-mp="ovn6jdp8bwhh">
                    {item.us}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}